import { render, staticRenderFns } from "./addTemplatePage.vue?vue&type=template&id=a94b69de&scoped=true&"
import script from "./addTemplatePage.vue?vue&type=script&lang=js&"
export * from "./addTemplatePage.vue?vue&type=script&lang=js&"
import style0 from "./addTemplatePage.vue?vue&type=style&index=0&id=a94b69de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94b69de",
  null
  
)

export default component.exports